<form #newModule (ngSubmit)="submit()" class="mb-0">
  <div class="fieldset w-100 mb-0">
    <label class="legend" for="mediaurl">Enter URL <span class="requiredfield">*</span></label>
    <input type="text" name="title" id="mediaurl" class="text-field" [(ngModel)]="mediaurl" required="required" (change)="urlChanged()">
  </div>
  <div #youtubediv class="d-flex justify-content-center"></div>
</form>
